import React, { useState } from "react";
import { FaEnvelope, FaLock } from "react-icons/fa"; // Import Font Awesome icons
import "./styles/Login.css";
import { useNavigate } from "react-router-dom";
import img from "../res/admin-img.png"; // You might want to update this if it needs translation
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase';
import { ADMIN_UID } from '../config'; 

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const navigate = useNavigate();
  
  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // Check if user is admin
      if (user.uid === ADMIN_UID) {
        navigate("/la-connexion-de-ladmin-ong-el-wifak-bargou/main");
      } else {
        setError('Vous n\'êtes pas autorisé en tant qu\'administrateur.');
      }
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <div className="Login">
      <div className="login-form">
        <h2>Connexion</h2>
        <form onSubmit={handleLogin}>
          <div className="input-container">
            <FaEnvelope className="icon" />
            <input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              id="email"
              placeholder="Adresse e-mail"
              required
            />
          </div>
          <div className="input-container">
            <FaLock className="icon" />
            <input
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              type="password"
              id="password"
              placeholder="Mot de passe"
              required
            />
          </div>
          <div>
            <button type="submit" id="signinbtn">Connexion</button>
          </div>
        </form>
        {error && <p>{error}</p>}
      </div>
    </div>
  );
};

export default Login;
